import Button from "components/button"
import ConfirmationJustificationDialog from "components/confirmation-justification-dialog";
import { useToastContext } from 'hooks/useToastContext';
import moment from 'moment'
import PropTypes from "prop-types"
import React, { useState } from 'react'
import intl from 'react-intl-universal'
import { fetchSuggestionsJustifications } from "services/suggestion/suggestion.service";
import { ISO_DATE_FORMAT } from 'utils/format-date';
import Session from 'utils/user-storage';
import ComposicaoCargaForm from '../../../../../composicao-carga/form'
import ModalAcceptReturn from '../../../../../primary-material-schedule/components/modalReturnSapList'
import { useLoadCompositionBuildingContext } from '../../../../context/load-composition-building-context';
import { createEmergencyNegotiation, criarComposicao, editarComposicao, fetchDesvincularPedidos, fetchUpdateDate } from '../../../../load-composition-building.service'
import { ModalAlert } from '../modalAlert';
import { getEmergencyNegotiationModel, hasOrdersWithoutJustification, validateHasChangedInRenegotiation } from './utils';

const ButtonAccept = ({
  isEditDateMode,
  data,
  setShowLoad,
  infosRoute,
  proccessError,
  pushPath,
  history,
  composicao,
  disabled,
  queryParams
}) => {
  const isEdit = !!infosRoute.composicaoId;
  const [modalAcceptReturnData, setModalAcceptReturnData] = useState({
    isOpen: false,
    data: [],
    title: intl.get('commons.composition')
  });
  const [showAcceptModal, setShowAcceptModal] = useState(false)
  const [idPedidoRetorno, setIdPedidoRetorno] = useState()
  const [showLoadCompositionModal, setShowLoadCompositionModal] = useState(false)
  const [showAlertModal, setShowAlertModal] = useState(false)

  const [showJustificationDialog, setShowJustificationDialog] = useState(false);
  const [justificationMessages, setJustificationMessages] = useState([]);
  const [isLoadingJustification, setIsLoadingJustification] = useState(false);
  const [pendingModel, setPendingModel] = useState(null);

  const {
    loadPage,
    isFullTruckLoad,
    breweryNote,
    ordersMetadata,
    isEmergencyNegotiation,
    selectedLoads,
    initialMetadata,
    loadComposition
  } = useLoadCompositionBuildingContext();
  const { openToast } = useToastContext();

  const handleCallbackEdit = () => {
    loadPage()
    setShowAcceptModal(false)
  }

  const handleEditDate = async (justificationId = null) => {
    if (hasDateChanged()) {
      const dto = {
        LoadCompositionId: parseInt(infosRoute.composicaoId),
        NewCompositionDeliveryDate: infosRoute.dia,
        NewCompositionDeliveryTime: infosRoute.hora,
        JustificationId: justificationId
      }
      
      await fetchUpdateDate(infosRoute.composicaoId, dto);
    }
  }

  const closeModalAssign = () => {
    setModalAcceptReturnData({
      data: [],
      isOpen: false
    });

    if (showLoadCompositionModal) {
      setShowAcceptModal(true);
    } else {
      history.push(pushPath);
    }
  }

  const openModalAssign = (model) => {
    setModalAcceptReturnData({
      data: model,
      isOpen: true,
      title: intl.get('commons.composition')
    });
  }

  const generateModelAccept = () => {
    const format = { idsSugestoes: [], idsPedidos: [] };
    const cards = data.filter(x => !x.IsNew);

    const labeledFamilyCenterIds = cards.map(card => card.IdFamiliaRotuladaCentro);
    cards.map(card => card.IdCard)
      .filter(id => id.includes('S') ?
        format.idsSugestoes.push(parseInt(id)) :
        format.idsPedidos.push(parseInt(id)));

    return {
      idsPedidos: format.idsPedidos,
      idsSugestoes: format.idsSugestoes,
      dataEntregaComposicao: infosRoute.dia,
      horaEntregaComposicao: infosRoute.hora,
      idFornecedor: data[0] ? data[0].IdFornecedor : infosRoute.fornecedorId,
      idUnidadeNegocio: parseInt(infosRoute.destinoId),
      doorDescription: queryParams.get('doorDescription'),
      breweryNote: breweryNote,
      labeledFamilyCenterIds: [...new Set(labeledFamilyCenterIds)]
    }
  }

  const atualizarPedidosComposicao = async (idsPedidos, justificationId = null) => {
    const dto = {
      OrdersIds: idsPedidos,
      LoadCompositionId: parseInt(infosRoute.composicaoId),
      JustificationId: justificationId
    }
    await fetchDesvincularPedidos(infosRoute.composicaoId, dto);
  }

  const hasDateChanged = () => {
    return (
      moment(composicao.DataEntrega).format(ISO_DATE_FORMAT) !== moment(infosRoute.dia).format(ISO_DATE_FORMAT) ||
      moment(composicao.HoraEntrega, "hh:mm").format("hh:mm") !== moment(infosRoute.hora, "hh:mm").format("hh:mm")
    );
  };

  const hasOrdersChanged = () => {
    const previousOrderIds = Array.isArray(composicao?.Pedidos)
      ? [...composicao.Pedidos].sort((a, b) => a - b)
      : [];
    const currentOrderIds = Array.isArray(generateModelAccept().idsPedidos)
      ? [...generateModelAccept().idsPedidos].sort((a, b) => a - b)
      : [];

    if (previousOrderIds.length !== currentOrderIds.length) return true;

    return previousOrderIds.some((id, idx) => id !== currentOrderIds[idx]);
  };

  const ensureJustifications = async () => {
    if (!justificationMessages.length) {
      setIsLoadingJustification(true);
      const response = await fetchSuggestionsJustifications();
      setJustificationMessages(response);
      setIsLoadingJustification(false);
    }
  };

  const handleConfirmJustification = (justificationId) => {
    setShowJustificationDialog(false);

    if (pendingModel) {
      accept(pendingModel, justificationId);
      setPendingModel(null);
    }
  };

  const handleAlertConfirm = async () => {
    setShowAlertModal(false);

    const needJustification = isEdit && !isEmergencyNegotiation && (hasDateChanged() || hasOrdersChanged());

    if (needJustification) {
      await ensureJustifications();
      setPendingModel(generateModelAccept());
      setShowJustificationDialog(true);
    } else {
      accept(generateModelAccept());
    }
  }

  const handleValidateAccept = async () => {
    const highLT = Math.max(...data.map((lci) => lci.TransitTime));
    const deliveryDate = moment(infosRoute.dia).startOf('day');
    const collectionDate = deliveryDate.clone().subtract(highLT, 'days');
    const today = moment().startOf('day');
    const _showAlert = collectionDate.isBefore(today);

    if (_showAlert) {
      setShowAlertModal(true);
      return;
    }

    const needJustification = isEdit && !isEmergencyNegotiation && (hasDateChanged() || hasOrdersChanged());    

    if (needJustification) {
      await ensureJustifications();
      setPendingModel(generateModelAccept());
      setShowJustificationDialog(true);
    } else {
      accept(generateModelAccept());
    }
  };

  const accept = async (model, justificationId = null) => {
    try {
      setShowLoad(true);
      let result;

      if (isEmergencyNegotiation) {
        const dataDeColeta = moment(model.dataEntregaComposicao).add(-composicao.TransitTime, 'day').format(ISO_DATE_FORMAT);
        const modelEmergencyNegotiation = getEmergencyNegotiationModel(infosRoute, model, dataDeColeta, ordersMetadata, selectedLoads, justificationId);
        const hasChanges = validateHasChangedInRenegotiation(initialMetadata, loadComposition, modelEmergencyNegotiation.PedidosMetaData, infosRoute)
        if (!hasChanges) {
          openToast(intl.get('commons.noChange'), 'warning')
          setShowLoad(false);
          return;
        }
        
        const needsJustification = hasOrdersWithoutJustification(modelEmergencyNegotiation.PedidosMetaData);
        
        if (needsJustification) {
          setShowLoad(false);
          await ensureJustifications();
          setPendingModel(model);
          setShowJustificationDialog(true);
          return;
        }

        await createEmergencyNegotiation(modelEmergencyNegotiation);

        setShowLoad(false);
        openModalAssign([intl.get('commons.renegotiationLoadCompositionSent')]);
        return;
      } else if (isEdit) {
        await atualizarPedidosComposicao(model.idsPedidos, justificationId)
        const _model = {
          LoadCompositionId: parseInt(infosRoute.composicaoId),
          BreweryNote: model.breweryNote,
          DoorDescription: model.doorDescription,
          OrdersIds: model.idsPedidos,
          SuggestionsIds: model.idsSugestoes,
          JustificationId: justificationId
        };

        result = await editarComposicao(infosRoute.composicaoId, _model);
        await handleEditDate(justificationId)
      } else {
        const _model = {
          SuggestionsIds: model.idsSugestoes,
          OrdersIds: model.idsPedidos,
          CompositionDeliveryDate: model.dataEntregaComposicao,
          CompositionDeliveryTime: model.horaEntregaComposicao,
          SupplierId: model.idFornecedor,
          BusinessUnitId: model.idUnidadeNegocio,
          BreweryNote: model.breweryNote,
          DoorDescription: model.doorDescription,
        };

        result = await criarComposicao(_model);
      }

      const pedidosComErro = result.filter(x => !x.Success) ?? [];

      if (pedidosComErro.length === 0) {
        const pedidosComSucesso = result.filter(x => x.Success);
        const idsPedidosComSucesso = pedidosComSucesso.map(x => x.CreatedOrderId);
        setIdPedidoRetorno(idsPedidosComSucesso[0]);
        setShowLoadCompositionModal(true);
      }
      openModalAssign(result.map(x => x.Message));
    }
    catch (e) {
      proccessError(e);
    }
    setShowLoad(false);
  }

  const validateDisableButton = () => !data[0] || disabled || (isEditDateMode && !isFullTruckLoad)

  return (
    <React.Fragment>
      <Button
        className='load-composition-accept'
        onClick={handleValidateAccept}
        buttonType='primary'
        value={isEmergencyNegotiation ? intl.get("commons.renegotiate") : intl.get("geral.buttonsDefault.accept")}
        disabled={validateDisableButton()}
        style={{ width: '112px', height: '26px', fontSize: '10px', marginLeft: '6px' }}
      />
      {modalAcceptReturnData.isOpen &&
        <ModalAcceptReturn
          open={modalAcceptReturnData.isOpen}
          data={modalAcceptReturnData.data}
          closeModalAssign={closeModalAssign}
          title={modalAcceptReturnData.title}
        />
      }
      {(idPedidoRetorno && showAcceptModal) &&
        <ComposicaoCargaForm
          idPedido={idPedidoRetorno}
          idUser={Session.get().Id}
          open={showAcceptModal}
          handleClose={() => {
            setShowAcceptModal(false);
            history.push(pushPath);
          }}
          modoLeitura={true}
          handleCallbackEdit={handleCallbackEdit}
        />
      }
      <ModalAlert
        open={showAlertModal}
        handleConfirm={handleAlertConfirm}
        handleClose={(() => setShowAlertModal(false))}
        title={intl.get("modalLcAlert.pickupDateInThePastTitle")}
        message={intl.get("modalLcAlert.pickupDateInThePastDueToTransitTime")}
      />
      <ConfirmationJustificationDialog
        show={showJustificationDialog}
        title={intl.get("transports.compoCharge.actions.acceptComposition")}
        labelButton={intl.get("composition.actions.accept")}
        labelButtonClose={intl.get("composition.actions.close")}
        handleConfirm={handleConfirmJustification}
        handleClose={() => setShowJustificationDialog(false)}
        justifications={justificationMessages}
        isLoading={isLoadingJustification}
      />
    </React.Fragment>
  )
}

ButtonAccept.propTypes = {
  composicao: PropTypes.shape({
    DataEntrega: PropTypes.any,
    HoraEntrega: PropTypes.any,
    TransitTime: PropTypes.any,
    Pedidos: PropTypes.array
  }).isRequired,
  data: PropTypes.shape({
    filter: PropTypes.func,
    map: PropTypes.func
  }).isRequired,
  disabled: PropTypes.any.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  infosRoute: PropTypes.shape({
    composicaoId: PropTypes.any,
    destinoId: PropTypes.any,
    dia: PropTypes.any,
    fornecedorId: PropTypes.any,
    hora: PropTypes.any
  }).isRequired,
  isEditDateMode: PropTypes.any.isRequired,
  proccessError: PropTypes.func.isRequired,
  pushPath: PropTypes.any.isRequired,
  queryParams: PropTypes.shape({
    get: PropTypes.func
  }).isRequired,
  setShowLoad: PropTypes.func.isRequired
}

export default ButtonAccept;
